import angular from 'angular';

import { cloneDeep, chunk, map, countBy, isEmpty } from 'lodash';

import Papa from 'papaparse';

import '../resources/organization-user';
import '../services/notifications';
import '../services/area';
import '../services/globals';
import '../app.constants';
import { spacesNotAllowed } from '../utils/stringFormatting';
const module = angular.module('whyline.services.organizationuser', [
  'whyline.resources.organizationuser',
  'whyline.services.notifications',
  'whyline.services.area',
  'whyline.services.globals',
  'whyline.constants',
]);

let User;
let GlobalsService;
let NotificationService;
let $translate;
let UserActions;

class OrganizationUserService {
  static $inject = [
    'OrganizationUser',
    'GlobalsService',
    'NotificationService',
    '$translate',
    'UserActions',
  ];
  static Me = undefined;
  static CurrentRole = undefined;

  constructor(
    injectedUser,
    injectedGlobalsService,
    injectedNotificationService,
    injected$translate,
    _UserActions,
  ) {
    /*@ngInject*/
    User = injectedUser;
    GlobalsService = injectedGlobalsService;
    NotificationService = injectedNotificationService;
    $translate = injected$translate;
    UserActions = _UserActions;
  }

  Create(data) {
    const newUser = new User(data);
    return User.Save(newUser);
  }

  Copy(user) {
    const copy = cloneDeep(user);
    return new User(copy);
  }

  Update(user) {
    return User.Save(user);
  }

  Remove(userId) {
    const user = User.FindById(userId);
    return User.Remove(user);
  }

  GetAll() {
    return User.FetchAll();
  }

  GetPendingAsPromise() {
    return User.FetchPending({ promise: true });
  }

  RemovePendingUser(userId) {
    return User.RemovePendingUser(userId);
  }

  GetAllAsPromise() {
    return User.FetchAll({ promise: true });
  }

  GetAllAsPromiseFromServer() {
    return User.FetchAll({ promise: true, force: true });
  }

  GetOne(userId) {
    return User.FindById(userId);
  }

  GetOneAsPromise(userId) {
    return User.FindById(userId, { promise: true });
  }

  GetOneAsPromiseFromServer(userId) {
    return User.FindById(userId, { promise: true, force: true });
  }

  SwitchOrganizationEnable(user) {
    return new User(user).enableForOrganization(!user.enabled);
  }

  DeleteUserForOrganization(
    userId,
    organizationId,
    deleteUserForOrganizationAndPlaces,
  ) {
    return User.deleteUserForOrganization(
      userId,
      organizationId,
      deleteUserForOrganizationAndPlaces,
    );
  }

  validateCsv(headingNotSpace, rows) {

    if (headingNotSpace.length !== 2) {
      return {
        data: {
          httpCode: 409,
          message: 'incorrect-number-of-headers'
        }
      }
    }

    const count = countBy(headingNotSpace);
    const result = map(count, (v, k) => ({ name: k, count: v }));
    const res = result.filter(head => head.count > 1);

    if (res.length) {
      return {
        data: {
          httpCode: 409,
          message: 'duplicate-header'
        }
      }
    }

    const rowsWithData = rows.filter(row => !isEmpty(row))

    if (rowsWithData.length <= 1) {
      return {
        data: {
          httpCode: 409,
          message: 'csv-file-wrong-data'
        }
      }
    }

  }

  SplitFileInChunks(file, limit = 100) {
    let error = {};
    let _self = this;
    return new Promise(fullfill => {
      Papa.parse(
        file,
        {
          skipEmptyLines: true,
          header: true,
          beforeFirstChunk: function (chunk) {
            const rows = chunk.split(/\r\n|\r|\n/);
            const headings = rows[0].split(',');
            const headingNotSpace = headings.map(head => spacesNotAllowed(head));
            error = _self.validateCsv(headingNotSpace, rows);
            return rows.join('\n');
          },
          complete: results => fullfill({
            rowsCount: results.data.length,
            chunks: chunk(results.data, limit),
            error
          }),
        }
      );
    });
  }

  async Link(file, limit, action) {
    const { rowsCount, chunks, error } = await this.SplitFileInChunks(file, limit);
    if (!isEmpty(error)) {
      throw error;
    }
    const tasks = map(chunks, chunkRowsToUpload => () => User.Link(chunkRowsToUpload, action, file.name.split('.').pop()));
    return { tasks, rowsCount };
  }
}

module.exports = module.service(
  'OrganizationUserService',
  OrganizationUserService,
);
